import React from 'react';
import { Link } from 'react-router-dom';
import { Box, Typography, Grid, Card, CardContent, Button, CardActions } from '@mui/material';
import { Add as AddIcon, List as ListIcon } from '@mui/icons-material';

const Dashboard = () => {
    return (
        <Box sx={{ p: 3 }}>
            <Typography variant="h4" sx={{ mb: 4 }}>Admin Dashboard</Typography>
            <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                    <Card sx={{ height: '100%' }}>
                        <CardContent>
                            <Typography variant="h6" gutterBottom>
                                Products Management
                            </Typography>
                            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                                Manage your product catalog, add new products, and update existing ones.
                            </Typography>
                        </CardContent>
                        <CardActions>
                            <Button
                                component={Link}
                                to="/admin/products/new"
                                startIcon={<AddIcon />}
                                variant="contained"
                                color="primary"
                            >
                                Add Product
                            </Button>
                            <Button
                                component={Link}
                                to="/admin/products"
                                startIcon={<ListIcon />}
                                variant="outlined"
                            >
                                View All
                            </Button>
                        </CardActions>
                    </Card>
                </Grid>
                <Grid item xs={12} md={6}>
                    <Card sx={{ height: '100%' }}>
                        <CardContent>
                            <Typography variant="h6" gutterBottom>
                                News Management
                            </Typography>
                            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                                Publish and manage news articles and updates for your website.
                            </Typography>
                        </CardContent>
                        <CardActions>
                            <Button
                                component={Link}
                                to="/admin/news/new"
                                startIcon={<AddIcon />}
                                variant="contained"
                                color="primary"
                            >
                                Add News
                            </Button>
                            <Button
                                component={Link}
                                to="/admin/news"
                                startIcon={<ListIcon />}
                                variant="outlined"
                            >
                                View All
                            </Button>
                        </CardActions>
                    </Card>
                </Grid>
            </Grid>
        </Box>
    );
};

export default Dashboard;
